module.exports = __webpack_public_path__ + "static/logo-ccbe30b1c05b9efc35e94085d9dee8d6.svg";